"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTooltip = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const StyledTooltip = props => {
  return /*#__PURE__*/_react.default.createElement(_material.Tooltip, _extends({}, props, {
    componentsProps: {
      ...props?.componentsProps,
      tooltip: {
        ...props?.componentsProps?.tooltip,
        sx: {
          borderRadius: "10px",
          border: "1px solid var(--color-accent)",
          background: "white",
          color: "var(--color-custom-black)",
          padding: "8px",
          fontSize: "0.875rem",
          ...props?.componentsProps?.tooltip?.sx
        }
      }
    }
  }));
};
exports.StyledTooltip = StyledTooltip;